import React from 'react';
import { Typography, Box, Button, Grid } from '@mui/material';
import { Link } from 'react-router';
import PremiumPlusIcon from '../../public/images/premium_plus.png';

import { styled } from '@mui/material/styles';

const StyledGrid = styled(Grid)(({ theme }) => ({
	width: '100%',
	marginLeft: 'auto',
	marginRight: 'auto'
}));

export const descriptions = [
	{
		id: 1,
		text: (
			<>
				<Typography component="span" variant="body2">
					Achiziționează un abonament <strong>Premium</strong> sau <strong> Premium PLUS+</strong>,
					dacă îți dorești să ai acces funcționalitățile platformei noastre.{' '}
				</Typography>
				<Typography component="span" variant="body2">
					Astfel, o să beneficiezi de acces complet la toate instrumentele esențiale ale platformei
					noastre de învățare: teste prestabilite, grile explicate, sinteze ale materiei,
					clasamentul concurenților, statistici relevante și îndrumări.{' '}
				</Typography>
				<br />
				<Typography
					sx={{
						color: 'grey',
						fontStyle: 'italic',
						display: 'flex'
					}}
					fontSize="13px"
					gutterBottom
					variant="button"
					component={Link}
					to={'/profil/premium'}
					key={'/profil/premium'}
				>
					Pentru mai multe detalii, citiți secțiunea de beneficii!
				</Typography>
			</>
		)
	},
	{
		id: 2,
		text: (
			<>
				<Typography component="span" variant="body2">
					<strong>Cont Premium</strong> și <strong>Cont Premium PLUS+</strong> îți oferă acces
					nelimitat la toate funcționalitățile platformei noastre.{' '}
				</Typography>
				<Typography component="span" variant="body2">
					Astfel, vei beneficia de acces complet la toate instrumentele esențiale ale platformei
					noastre de învățare: grile explicate, sinteze ale materiei, clasamentul concurenților,
					statistici relevante și îndrumări.
				</Typography>
			</>
		)
	},
	{
		id: 3,
		text: (
			<>
				<Typography component="span" variant="body2">
					<strong>Contul Premium PLUS+</strong> îți oferă posiblitatea de a rezolva grile și teste
					explicate fără limite zilnice! Totodată, poți genera teste doar din grilele care ți-au pus
					dificultăți în trecut!
				</Typography>
			</>
		)
	}
];

export default function InactiveSubscription(props) {
	const { description, benefitsLinkPath, subscriptionsLinkPath, subscriptionLinkTitle, fontColor } =
		props;

	return (
		<StyledGrid container display="flex" flexDirection="column" alignItems="left" spacing={2}>
			<Grid item xs={12} sm={12}>
				<Box
					component="img"
					alt="Premium."
					sx={{ height: '70px', width: '70px', float: 'left', marginRight: '16px' }}
					src={PremiumPlusIcon}
				/>
				<Box sx={{ color: fontColor ? fontColor : 'primary' }}>{description?.text}</Box>
			</Grid>
			<Grid item xs={12} sm={12} display="flex" justifyContent="end">
				<Link
					to={{
						pathname: benefitsLinkPath
					}}
					style={{ textDecoration: 'inherit' }}
				>
					<Button
						variant="outlined"
						sx={{
							margin: '5px',
							color: fontColor ? fontColor : 'primary',
							borderColor: fontColor ? fontColor : 'primary'
						}}
					>
						Beneficii
					</Button>
				</Link>

				<Link
					to={{
						pathname: subscriptionsLinkPath
					}}
					style={{ textDecoration: 'inherit' }}
				>
					<Button variant="contained" color="primary" sx={{ margin: '5px' }}>
						{subscriptionLinkTitle ? subscriptionLinkTitle : 'Abonamente'}
					</Button>
				</Link>
			</Grid>
		</StyledGrid>
	);
}
